import { ReactNode } from 'react';

import Card from '@mui/material/Card';
import CardContent, { CardContentProps } from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface DataListRow {
  label: string;
  value: ReactNode | string;
}

interface DataListProps {
  rows: DataListRow[];
  actionButtons?: ReactNode;
  sx?: CardContentProps['sx'];
}

const DataList = ({ rows, actionButtons = null, sx = {} }: DataListProps) => {
  return (
    <Card data-testid="mobile-view-data-table">
      <CardContent sx={sx}>
        <Stack spacing={1}>
          {rows?.map((row, index) => (
            <Stack key={row.label}>
              <Stack direction="column" spacing={1} p={2}>
                <Typography variant="h5">{row.label}</Typography>
                <Typography variant="body2">{row.value}</Typography>
              </Stack>
              {index < rows.length - 1 && <Divider sx={{ mt: 1 }} />}
            </Stack>
          ))}
          {actionButtons && (
            <Stack spacing={2} data-testid="action-buttons">
              {actionButtons}
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default DataList;
